import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { authService } from '../services/authService';
import './BottomNavShell.css';
import './CompetitionBottomNav.css';

const BASE_TABS = [
  { path: '/competitions/broadcast', icon: '📡', label: 'Broadcast', match: (p) => p === '/competitions/broadcast' },
  { path: '/my-competition', icon: '⚡', label: 'My Status', match: (p) => p === '/my-competition' }
];

const DELEGATE_TAB = { path: '/competitions', icon: '⚙️', label: 'Ops', match: (p) => p === '/competitions' };

function CompetitionBottomNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const currentUser = authService.getCurrentUser();
  const isDelegate = currentUser?.role === 'admin' || (currentUser?.featureRoles || []).includes('transformers_competition');

  const tabs = isDelegate ? [...BASE_TABS, DELEGATE_TAB] : BASE_TABS;

  return (
    <nav className="bn-shell tc-bottomnav">
      {tabs.map((tab) => {
        const isActive = tab.match(location.pathname);
        return (
          <button
            key={tab.label}
            type="button"
            className={`bn-shell-item tc-bottomnav-item ${isActive ? 'active' : ''}`}
            onClick={() => navigate(tab.path)}
          >
            <span className="bn-shell-icon tc-bottomnav-icon">{tab.icon}</span>
            <span className="tc-bottomnav-label">{tab.label}</span>
          </button>
        );
      })}
    </nav>
  );
}

export default CompetitionBottomNav;
